import React from "react";
import { TbGalaxy } from "react-icons/tb";

const RotatingLogo = () => {
    return (
        <div className="rotate_logo">
            <i
                type="button"
                className="mainframe_sidebar_logo fade-in"
                aria-label="Home"
            >
                <TbGalaxy />
            </i>
        </div>
    )
}

export default RotatingLogo